<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import i18n from "@/i18n";
import { mapState } from "vuex";
import { CONFIGURATION_MODULE } from '@/state/modules/configuration'
import { configurationMethods } from "@/state/helpers";
import ImageUploader from '@/components/upload-image';

export default {
  page: {
    title: i18n.t("label.updateFormX", [i18n.t("module.configuration")]),
  },
  components: { Layout, PageHeader, ImageUploader },
  beforeRouteLeave(to, from, next) {
    if (to.name != "Configuration-listing") {
      sessionHelper.clearSearch(SESSION.CONFIGURATION_SEARCH);
    }
    next();
  },
  computed: {
    ...mapState(CONFIGURATION_MODULE, ["status"]),
    data() {
      return this.$store.state.configuration.details;
    },
  },
  data() {
    return {
      title: i18n.t("label.updateFormX", [i18n.t("module.configuration")]),
      items: [
        {
          text: i18n.t("module.dashboard"),
          href: "/",
        },
        {
          text: i18n.t("module.configuration"),
          href: "/configuration",
        },
        {
          text: i18n.t("label.updateX", [i18n.t("module.configuration")]),
          active: true,
        },
      ],
      submitted: false,
      statusDdl: ddlHelper.getActivationStatus(false, false),
    };
  },
  validations: {
    data: {
      key: { required },
      value: { required },
    },
  },
  created() {
    this.searchCriteria = sessionHelper.retrieveSearch(
      SESSION.CONFIGURATION_SEARCH
    );
    this.getConfigurationDetails();
  },
  methods: {
    ...configurationMethods,
    updateImage(image) {
      this.data.value = image[0].url;
      this.data.updateValue = image[0].file
    },
    getConfigurationDetails() {
      this.getConfiguration({ key: this.searchCriteria.selectedRecordId, });
    },
    requestUpdate() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        let data = {};

        if (this.data.valueType == "image" || this.data.valueType == "imageArray") {
          if (this.data.valueType == "image") {

            data = {
              key: this.data.key,
              value: this.data.updateValue,
              valueType: this.data.valueType
            };
          }
        }
        else {
          data = {
            key: this.data.key,
            value: this.data.value,
            valueType: this.data.valueType
          };
        }

        this.updateConfiguration({ data });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="requestUpdate">
              <b-form-group id="name" label-cols-sm="2" label-cols-lg="2" :label="$t('label.name')" label-for="name">
                <b-form-input for="name" v-model.trim="data.key" :class="{ 'is-invalid': !$v.data.key.required }"
                  disabled></b-form-input>
                <div v-if="!$v.data.key.required" class="invalid-feedback">
                  <span v-if="!$v.data.key.required">{{
                    $t("message.requiredX", [$t("label.name")])
                    }}</span>
                </div>
              </b-form-group>

              <b-form-group id="value" label-cols-sm="2" label-cols-lg="2" :label="$t('label.value')" label-for="value">
                <b-form-input for="value" v-model.trim="data.value" :class="{ 'is-invalid': !$v.data.value.required }"
                  type="text" v-if="data.valueType == 'string'"></b-form-input>

                <b-form-input for="value" v-model.trim="data.value" :class="{ 'is-invalid': !$v.data.value.required }"
                  type="number" v-else-if="data.valueType == 'integer'"></b-form-input>

                <b-form-input for="value" v-model.trim="data.value" :class="{ 'is-invalid': !$v.data.value.required }"
                  type="number" step="0.01" v-else-if="data.valueType == 'double'"></b-form-input>

                <b-form-input for="value" v-model.trim="data.value" :class="{ 'is-invalid': !$v.data.value.required }"
                  type="date" v-else-if="data.valueType == 'date'"></b-form-input>

                <b-form-input for="value" v-model.trim="data.value" :class="{ 'is-invalid': !$v.data.value.required }"
                  type="datetime" v-else-if="data.valueType == 'dateTime'"></b-form-input>

                <ImageUploader :initialImages="[data.value]" :multiple="false"
                  :buttonText="'Choose ' + data.key.replace(/_/g, ' ')" @images-changed="updateImage"
                  v-else-if="data.valueType == 'image'" />

                <div v-else-if="data.valueType == 'boolean'">
                  <select class="custom-select" v-model.trim="data.value">
                    <option v-for="status in statusDdl" :value="status.value" v-bind:key="status.value">
                      {{ status.text }}
                    </option>
                  </select>
                </div>


                <div v-if="!$v.data.value.required" class="invalid-feedback">
                  <span v-if="!$v.data.value.required">{{
                    $t("message.requiredX", [$t("label.value")])
                    }}</span>
                </div>
              </b-form-group>

              <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px; float: right;" type="submit"
                :disabled="status.update">
                {{ $t("label.updateX", [$t("module.configuration")]) }}
              </button>
            </form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>